import React, { useRef } from "react";
import { bool, func } from "prop-types";

import Modal from "@components/shared/Modal";
import { useTranslation } from "@lib/i18n";
import PhoneIcon from "@components/shared/Icons/PhoneIcon";

const SellerContactModal = ({ isOpen, closeModal }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      ariaLabel={t("header.sellerContactModal.heading")}
      onClose={closeModal}
      closeButtonDataId="seller-contact-close-icon"
      withCloseIcon
    >
      <div
        className="flex flex-col items-center h-full gap-4 py-16 text-center"
        data-id="seller-contact-modal"
      >
        <h4 className="text-xl font-semibold">
          {t("header.sellerContactModal.heading")}
        </h4>
        <p>{t("header.sellerContactModal.text")}</p>
        <a
          className="flex gap-2 items-center font-semibold text-lg/tight hover:bg-greyLight/50 px-4 py-2 rounded-md transition duration-150 hover:scale-105 active:scale-95"
          href={`tel:${t("header.sellerContactModal.number")}`}
          ref={modalLastElement}
        >
          <PhoneIcon className="text-primaryOrange" />
          <span>{t("header.sellerContactModal.number")}</span>
        </a>
      </div>
    </Modal>
  );
};

SellerContactModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
};

export default SellerContactModal;
